// extracted by mini-css-extract-plugin
export default {"fillColor":"NotFoundIcon_fillColor__j659K"};